import { createContext } from 'react'

const PageContext = createContext({
  page: '',
  setCurrentPage: lang => false,
})

export default PageContext
